import { Pedido } from '@/models/sit-pedido/pedido';

export interface DetailSitPedidos {
  data: Pedido;
  isLoading: Boolean;
}

const detailState: DetailSitPedidos = {
  data: null,
  isLoading: false
}

export default detailState;
